export { EventDetailCapacity } from "./EventDetailCapacity";
